import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { useState, useCallback, useRef } from 'react';
import { useClient } from '../context';
import { ChatCreateMessageMutation, ChatCreateConversationMutation } from '../mutation';
var createProductFields = function createProductFields(product, structure) {
  var _structure$config;
  var createField = function createField(name, value) {
    return {
      name: name,
      value: value
    };
  };
  return [createField('productId', product.id), createField('productTitle', product.title), createField('productImage', product.image), createField('productUrl', "".concat(structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.desktopSiteDomain, "/").concat(product.url))];
};
export var normalizeError = function normalizeError(response, fallback) {
  var _data$createMessage;
  var _ref = response || {},
    errors = _ref.errors,
    data = _ref.data,
    networkError = _ref.networkError,
    message = _ref.message;
  if (errors == null ? void 0 : errors.length) {
    return {
      allowRetry: true,
      message: errors.map(function (err) {
        return err.message;
      }).join('\r\n')
    };
  }
  if ((data == null ? void 0 : (_data$createMessage = data.createMessage) == null ? void 0 : _data$createMessage.slug) === 'UNPROCESSABLE_ENTITY') {
    return {
      allowRetry: false,
      message: data.createMessage.detail.map(function (err) {
        return err.msg;
      }).join('\r\n')
    };
  }
  if (networkError) {
    var _networkError$result;
    var resultErrors = (_networkError$result = networkError.result) == null ? void 0 : _networkError$result.errors;
    if (resultErrors) {
      return {
        allowRetry: true,
        message: resultErrors.map(function (err) {
          return err.message;
        }).join('\r\n')
      };
    }
    return {
      allowRetry: true,
      message: networkError.message
    };
  }
  return {
    allowRetry: false,
    message: message || fallback
  };
};
var useChatPostMessage = function useChatPostMessage(_ref2) {
  var product = _ref2.product,
    sender = _ref2.sender,
    staticProps = _ref2.staticProps,
    structure = _ref2.structure;
  var productAdded = useRef({});
  var client = useClient();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var createConversation = useCallback(function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(store) {
      var _data$createConversat;
      var _yield$client$mutate, data, errors;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.mutate({
              mutation: ChatCreateConversationMutation,
              variables: {
                request: {
                  channel: staticProps.channel,
                  organization: staticProps.organization,
                  owner: {
                    name: store.description,
                    refKey: store.id
                  },
                  user: {
                    fullName: sender.fullname,
                    refKey: sender.id,
                    type: 'CUSTOMER',
                    username: sender.username
                  }
                }
              }
            });
          case 2:
            _yield$client$mutate = _context.sent;
            data = _yield$client$mutate.data;
            errors = _yield$client$mutate.errors;
            if (!(errors || !(data == null ? void 0 : (_data$createConversat = data.createConversation) == null ? void 0 : _data$createConversat.id))) {
              _context.next = 8;
              break;
            }
            setLoading(false);
            throw new Error('Ocorreu um erro ao criar a conversa com o seller.');
          case 8:
            return _context.abrupt("return", data.createConversation);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [sender]);
  var postMessage = useCallback(function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(store, conversationId, message, lastProduct) {
      var result, conversation, _resultMessage$data, _resultMessage$data$c, _resultMessage$data2, resultMessage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (message) {
              _context2.next = 3;
              break;
            }
            throw new Error('The argument /message/ does not have a valid value.');
          case 3:
            if (sender) {
              _context2.next = 5;
              break;
            }
            throw new Error('The hook was not initialized correctly. The /sender/ argument does not have a valid value.');
          case 5:
            setLoading(true);
            result = {
              conversationId: conversationId
            };
            if (conversationId) {
              _context2.next = 12;
              break;
            }
            _context2.next = 10;
            return createConversation(store);
          case 10:
            conversation = _context2.sent;
            result.conversationId = conversation == null ? void 0 : conversation.id;
          case 12:
            if (!(product && !productAdded.current[product == null ? void 0 : product.id] && product.id !== lastProduct)) {
              _context2.next = 16;
              break;
            }
            _context2.next = 15;
            return client.mutate({
              mutation: ChatCreateMessageMutation,
              variables: {
                channel: staticProps.channel,
                content: 'PRODUCT_MESSAGE',
                conversationId: result.conversationId,
                customFields: createProductFields(product, structure),
                integration: true,
                organization: staticProps.organization,
                userFullname: sender.fullname,
                userId: sender.id,
                userName: sender.username
              }
            });
          case 15:
            productAdded.current[product.id] = true;
          case 16:
            _context2.prev = 16;
            _context2.next = 19;
            return client.mutate({
              mutation: ChatCreateMessageMutation,
              variables: {
                channel: staticProps.channel,
                content: message.content,
                conversationId: result.conversationId,
                organization: staticProps.organization,
                userFullname: sender.fullname,
                userId: sender.id,
                userName: sender.username
              }
            });
          case 19:
            resultMessage = _context2.sent;
            if (!((resultMessage == null ? void 0 : (_resultMessage$data = resultMessage.data) == null ? void 0 : (_resultMessage$data$c = _resultMessage$data.createMessage) == null ? void 0 : _resultMessage$data$c.__typename) === 'ChatErrorResponse')) {
              _context2.next = 22;
              break;
            }
            throw resultMessage;
          case 22:
            return _context2.abrupt("return", _extends({}, result, {
              message: resultMessage == null ? void 0 : (_resultMessage$data2 = resultMessage.data) == null ? void 0 : _resultMessage$data2.createMessage
            }));
          case 25:
            _context2.prev = 25;
            _context2.t0 = _context2["catch"](16);
            throw normalizeError(_context2.t0);
          case 28:
            _context2.prev = 28;
            setLoading(false);
            return _context2.finish(28);
          case 31:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0,, 28, 31], [16, 25]]);
    }));
    return function (_x2, _x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }(), [client, sender, createConversation]);
  return {
    loading: loading,
    postMessage: postMessage
  };
};
export default useChatPostMessage;